(function () {
  'use strict';

  /* Substrings used to identify FAQ entries to hoist for each trigger. Substring
     match is case-insensitive against summary.textContent. Up to 3 hoisted, the
     first is pre-expanded. */
  var faqMatchers = {
    falls: ['fall detection', 'cannot speak', 'how quickly', 'how accurate'],
    'living-alone': ['cannot speak', 'outside the home', 'outside the house', 'comfortable to wear', 'how long does the battery'],
    outside: ['outside the home', 'outside the house', 'family see the gps', 'how long does the battery'],
    switchover: ['smartphone, wi-fi', '2027', 'what network', '4g signal'],
    hospital: ['try it before', 'how long does the battery', 'comfortable to wear', 'how quickly']
  };

  /* Feature pills (the small icon tags under the hero subhead) reorder, by trigger.
     Substring match against the pill's textContent. Triggers without a clear pill
     mapping fall through with no-op. */
  var pillMatchers = {
    falls: ['fall detection'],
    outside: ['gps', 'water'],
    'living-alone': ['two-way']
  };

  var triggerCopy = {
    falls: {
      h1: 'After a fall, help is one button away.',
      sub: "If they can't get up, one press connects them to a real UK operator who can hear them, talk them through it, and send help.",
      ack: 'You told us about a fall or near miss. This is built for exactly that.'
    },
    'living-alone': {
      h1: "Living alone shouldn't mean alone in an emergency.",
      sub: 'Morning, midnight, or 3 a.m. on a Sunday. Someone real is there in under 60 seconds.',
      ack: "You told us they live alone. Here's why this works at any hour."
    },
    outside: {
      h1: 'Protection that works wherever they go.',
      sub: 'Walks, the shops, gardening, the bus, visiting family. UK-wide 4G coverage, no Wi-Fi or landline needed.',
      ack: "You told us they need protection outside the home. Here's how this keeps up."
    },
    switchover: {
      h1: 'Switch to 4G before the 2027 deadline.',
      sub: 'No landline. No Wi-Fi. No engineer visit. It plugs in, charges, and works UK-wide on 4G.',
      ack: "You told us you're replacing an old landline alarm. Here's the simple way to switch over."
    },
    hospital: {
      h1: 'Reassurance for the first weeks home.',
      sub: 'After discharge, the worry is being alone if something goes wrong. One button takes that worry off the table.',
      ack: "You told us about coming home from hospital. Here's how to be set up before they're back."
    }
  };

  function readParam(name) {
    var v = '';
    try {
      v = (new URLSearchParams(window.location.search).get(name) || '').toLowerCase();
    } catch (err) {}
    if (v) return v;
    try {
      return (sessionStorage.getItem(name) || '').toLowerCase();
    } catch (err) {
      return '';
    }
  }

  function track(name, payload) {
    try {
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push(Object.assign({ event: name }, payload || {}));
      }
    } catch (err) {}
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, payload || {});
      }
    } catch (err) {}
    try {
      if (window.fbq) window.fbq('trackCustom', name, payload || {});
    } catch (err) {}
  }

  function apply() {
    var trigger = readParam('hg_trigger');
    if (!trigger || !triggerCopy[trigger]) return;

    var copy = triggerCopy[trigger];

    var h1 = document.querySelector('[data-hg-personalise="h1"]');
    if (h1) h1.textContent = copy.h1;

    var sub = document.querySelector('[data-hg-personalise="sub"]');
    if (sub) sub.textContent = copy.sub;

    var ack = document.querySelector('[data-hg-personalise="ack"]');
    if (ack) {
      var ackText = ack.querySelector('[data-hg-ack-text]');
      if (ackText) ackText.textContent = copy.ack;
      ack.style.display = 'inline-flex';
    }

    pinFaqs(trigger);
    reorderPills(trigger);

    track('quiz_personalisation_shown', {
      trigger: trigger,
      recommendation: readParam('hg_recommendation')
    });
  }

  function pinFaqs(trigger) {
    var matchers = faqMatchers[trigger];
    if (!matchers || !matchers.length) return;

    var allDetails = document.querySelectorAll('details');
    if (!allDetails.length) return;

    /* Collect details whose summary matches any substring, preserving original
       DOM order. Cap at 3 per page. */
    var matched = [];
    for (var i = 0; i < allDetails.length && matched.length < 3; i++) {
      var summary = allDetails[i].querySelector('summary');
      if (!summary) continue;
      var text = (summary.textContent || '').toLowerCase();
      for (var j = 0; j < matchers.length; j++) {
        if (text.indexOf(matchers[j]) !== -1) {
          matched.push(allDetails[i]);
          break;
        }
      }
    }
    if (!matched.length) return;

    /* Hoist matched details to the top of their parent. Insert in reverse so the
       first match ends up at the top of the list. */
    for (var k = matched.length - 1; k >= 0; k--) {
      var d = matched[k];
      var parent = d.parentNode;
      if (parent) parent.insertBefore(d, parent.firstChild);
    }

    /* Pre-expand the first match so the buyer sees their answer immediately */
    matched[0].setAttribute('open', '');
  }

  function reorderPills(trigger) {
    var matchers = pillMatchers[trigger];
    if (!matchers || !matchers.length) return;

    var groups = document.querySelectorAll('[data-hg-feature-pills]');
    if (!groups.length) return;

    groups.forEach(function (group) {
      var pills = Array.prototype.slice.call(group.children);
      var matched = [];
      for (var i = 0; i < pills.length; i++) {
        var t = (pills[i].textContent || '').toLowerCase();
        for (var j = 0; j < matchers.length; j++) {
          if (t.indexOf(matchers[j]) !== -1) {
            matched.push(pills[i]);
            break;
          }
        }
      }
      for (var k = matched.length - 1; k >= 0; k--) {
        group.insertBefore(matched[k], group.firstChild);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
